import {
  FIRST_PAGINATION_INDEX,
  PAGINATION_DELTA,
} from './Pagination.constants'

export const pagination = (current, last) => {
  let left = current - PAGINATION_DELTA
  let right = current + PAGINATION_DELTA + 1

  // Reajust boundaries if necessary
  if (right > last) {
    left += last - right + 1
  }

  if (left < FIRST_PAGINATION_INDEX) {
    right += FIRST_PAGINATION_INDEX - left
  }

  left = Math.max(left, FIRST_PAGINATION_INDEX)
  right = Math.min(right, last + 1)

  const pagesToDisplay = right - left

  if (pagesToDisplay > 1) {
    return Array.from({ length: pagesToDisplay }, (_, i) => left + i)
  }

  return []
}
